if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          thumbnailsSlider: this.querySelector('[id^="ThumbnailsSlider"]'),
          mainSlider: this.querySelector('[id^="MainSlider"]'),
        };

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
        }

        if (this.elements.thumbnailsSlider) {
          this.thumbnailsSlider = new Swiper(this.elements.thumbnailsSlider, {
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            observer: true,
            observeParents: true,
            loop: false,
          });
          this.thumbnailsSlider.slides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
              this.thumbnailsSlider.slideTo(index, 300);
            });
          });
        }

        if (this.elements.mainSlider) {
          this.mainSlider = new Swiper(this.elements.mainSlider, {
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            effect: 'fade',
            fadeEffect: {
              crossFade: true,
            },
            navigation: {
              nextEl: this.elements.mainSlider.querySelector('.swiper-button-next'),
              prevEl: this.elements.mainSlider.querySelector('.swiper-button-prev'),
            },
            thumbs: this.thumbnailsSlider ? { swiper: this.thumbnailsSlider } : undefined,
            loop: false,
            on: {
              slideChange: (swiper) => {
                if (!this.elements.thumbnails) return;

                const mediaId = swiper.slides[swiper.activeIndex].dataset.mediaId;
                if (!mediaId) return;

                const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                this.setActiveThumbnail(activeThumbnail);
              },
            },
          });
        }
      }

      setActiveMedia(mediaId, isMainSlider = true) {
        const activeMedia = this.elements.mainSlider.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const mediaIndex = Number(activeMedia.dataset.mediaIndex);

        if (this.mainSlider) {
          if (mediaIndex >= 0 && mediaIndex < this.mainSlider.slides.length) {
            this.mainSlider.slideTo(mediaIndex, 300);
          } else {
            console.warn('Slide index out of range:', mediaIndex, 'total slides:', this.mainSlider.slides.length);
          }
        }

        this.preventStickyHeader();
        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll('button')
            .forEach((element) => element.removeAttribute('aria-current'));
        }
        if (thumbnail) {
          thumbnail.querySelector('button').setAttribute('aria-current', true);
        }
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
    }
  );
}
